import { canSee } from "@/lib/menus";
import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { rupiah } from "@/lib/format";

const NONE = "__none__";

// Pilih akun Kas & Bank. Bila kosong → otomatis isi akun default (Kas Utama) kecuali allowNone.
// Disembunyikan bila user tidak punya permission menu "Kas & Bank → Akun" (backend memakai akun default Kas Utama).
// Wajib dipilih (tidak diisi otomatis). pabrikId → tampilkan akun milik pabrik tsb + akun Pusat (untuk transaksi internal).
export default function AkunSelect({ value, onChange, label = "Dibayar dari akun", testid = "akun-select", allowNone = false, noneLabel = "Tidak memengaruhi kas", className = "", showSaldo = true, pabrikId = null }) {
  const { user } = useAuth();
  const allowed = canSee(user, "akun");
  const [akun, setAkun] = useState([]);
  useEffect(() => {
    if (!allowed) return;
    api.get("/akun", { params: pabrikId ? { all: 1 } : {} })
      .then((r) => setAkun((r.data || []).filter((a) => !pabrikId || !a.pabrik_id || a.pabrik_id === pabrikId)))
      .catch(() => setAkun([]));
  }, [allowed, pabrikId]);
  if (!allowed) return null;
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && <Label>{label}</Label>}
      <Select value={value || (allowNone ? NONE : "")} onValueChange={(v) => onChange(v === NONE ? null : v)}>
        <SelectTrigger data-testid={testid} className={!value && !allowNone ? "border-amber-300" : ""}><SelectValue placeholder="Pilih akun (wajib)"/></SelectTrigger>
        <SelectContent>
          {allowNone && <SelectItem value={NONE}>{noneLabel}</SelectItem>}
          {akun.map((a) => (
            <SelectItem key={a.id} value={a.id}>
              {a.nama}{a.no_rekening ? ` (${a.no_rekening})` : ""}{a.pabrik_id ? "" : a.pabrik_nama ? " · Pusat" : ""}{showSaldo ? ` — ${rupiah(a.saldo)}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
